import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  Popover,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import {
  CategoriesIcon,
  EditIcon,
  LinkIcon,
  PlusCircleIcon,
  TeamIcon,
} from "@shopify/polaris-icons";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
const Items = () => {
  const { id, subcategoryId } = useParams();
  const format = "YYYY-MM-DD HH:mm:ss";
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddItem = () => {
    navigate(
      `/admin/categories/${id}/subcategories/${subcategoryId}/items/new`
    );
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Name", value: "name" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: false,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);

  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `/categories/${id}/sub-categories/${subcategoryId}/items?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "name" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: response.data.data.map((item, index) => [
          item?.name?.en ?? "-",
          <Thumbnail source={item.icon} size="small" />,
          <Button
            onClick={() => window.open(item.mp3, "_blank")}
            variant="plain"
          >
            <Icon source={LinkIcon}></Icon>
          </Button>,
          moment(item.created_at).format(format),
          <Badge tone={item.is_active ? "success" : "info"}>
            {item.is_active ? "Active" : "Inactive"}
          </Badge>,
          <ButtonGroup>
            {/* <Button
              icon={CategoriesIcon}
              onClick={() =>
                navigate(
                  `/admin/categories/${id}/subcategories/${item.id}/items`
                )
              }
            >
              Items
            </Button> */}
            <Button
              icon={EditIcon}
              onClick={() =>
                navigate(
                  `/admin/categories/${id}/subcategories/${subcategoryId}/items/${item.id}`
                )
              }
            >
              Edit
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !response.data.data.length ? true : false,
        tableTotalPages: response.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This item has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [isSaving, setIsSaving] = useState(false);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/value-added-services/${id}/subcategories/${currentID.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const currentID = useRef("");
  const handleQueryChange = (value) => {
    refBoolPage.current = false;
    setQueryValue(value);
  };
  const [filterActive, setFilterActive] = useState(false);
  const toggleFilterActive = useCallback(() => setFilterActive((a) => !a), []);
  const filterChoices = [{ label: "Title", value: "title" }];
  return (
    <Page
      title="Items"
      primaryAction={
        <Button variant="primary" onClick={handleAddItem} icon={PlusCircleIcon}>
          Add Item
        </Button>
      }
      backAction={{
        onAction: () => navigate(`/admin/categories/${id}/subcategories`),
      }}
    >
      <Card padding="0">
        {loadingMarkup}
        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search by name"
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Image
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Sound
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            onAction: handleChangeModalDelete,
            loading: isSaving,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to delete this item?</Text>
        </Modal.Section>
      </Modal>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default Items;
